// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";

function cmp(param, param$1) {
  let match = param$1.groupFullId;
  let match$1 = param.groupFullId;
  let c = Primitive_int.compare(match$1[0], match[0]);
  if (c !== 0) {
    return c;
  } else {
    return Primitive_int.compare(match$1[1], match[1]);
  }
}

let NamedGroupCmp = Belt_Id.MakeComparable({
  cmp: cmp
});

function aggregate(rows) {
  let len = rows.length;
  if (len !== 1) {
    if (len !== 0) {
      return Stdlib_Array.reduce(rows.slice(1), rows[0], (a, b) => {
        let totalSamples = a.samples + b.samples | 0;
        return {
          freeMin: Math.min(a.freeMin, b.freeMin),
          freeMax: Math.max(a.freeMax, b.freeMax),
          freeMean: (a.freeMean * a.samples + b.freeMean * b.samples) / totalSamples,
          occupiedMin: Math.min(a.occupiedMin, b.occupiedMin),
          occupiedMax: Math.max(a.occupiedMax, b.occupiedMax),
          occupiedMean: (a.occupiedMean * a.samples + b.occupiedMean * b.samples) / totalSamples,
          errorMin: Math.min(a.errorMin, b.errorMin),
          errorMax: Math.max(a.errorMax, b.errorMax),
          errorMean: (a.errorMean * a.samples + b.errorMean * b.samples) / totalSamples,
          inflow: a.inflow + b.inflow | 0,
          outflow: a.outflow + b.outflow | 0,
          samples: totalSamples
        };
      });
    } else {
      return;
    }
  } else {
    return rows[0];
  }
}

let namedGroup = Jzon.object2(param => [
  param.groupFullId,
  param.name
], param => ({
  TAG: "Ok",
  _0: {
    groupFullId: param[0],
    name: param[1]
  }
}), Jzon.field("groupFullId", SensorGroups$LumiStaticData.GroupFullId.jsonCodec), Jzon.field("name", Jzon.string));

let sensorGroupStateHistoryAggregate = Jzon.object12(param => [
  param.freeMin,
  param.freeMax,
  param.freeMean,
  param.occupiedMin,
  param.occupiedMax,
  param.occupiedMean,
  param.errorMin,
  param.errorMax,
  param.errorMean,
  param.inflow,
  param.outflow,
  param.samples
], param => ({
  TAG: "Ok",
  _0: {
    freeMin: param[0],
    freeMax: param[1],
    freeMean: param[2],
    occupiedMin: param[3],
    occupiedMax: param[4],
    occupiedMean: param[5],
    errorMin: param[6],
    errorMax: param[7],
    errorMean: param[8],
    inflow: param[9],
    outflow: param[10],
    samples: param[11]
  }
}), Jzon.field("freeMin", Jzon.int), Jzon.field("freeMax", Jzon.int), Jzon.field("freeMean", Jzon.float), Jzon.field("occupiedMin", Jzon.int), Jzon.field("occupiedMax", Jzon.int), Jzon.field("occupiedMean", Jzon.float), Jzon.field("errorMin", Jzon.int), Jzon.field("errorMax", Jzon.int), Jzon.field("errorMean", Jzon.float), Jzon.field("inflow", Jzon.int), Jzon.field("outflow", Jzon.int), Jzon.field("samples", Jzon.int));

let sensorGroupStateHistoryAggregateRow = LumiJzon.tuple2(LumiDate.DateTime.jsonCodec, sensorGroupStateHistoryAggregate);

let JsonCodecs = {
  namedGroup: namedGroup,
  sensorGroupStateHistoryAggregate: sensorGroupStateHistoryAggregate,
  sensorGroupStateHistoryAggregateRow: sensorGroupStateHistoryAggregateRow
};

export {
  NamedGroupCmp,
  aggregate,
  JsonCodecs,
}
/* NamedGroupCmp Not a pure module */
